export default "__VITE_ASSET__BszINHdx__"